import { useEffect, useState } from "react";
import { Outlet, useLocation, useParams } from "react-router";
import { useLiveEvents } from "../lib/liveEvents";
import { Icon } from "./Icon";
import { Sidebar } from "./Sidebar";

export const LAST_PROJECT_KEY = "atr:lastProject";

export function Layout() {
  const { pid } = useParams();
  const [navOpen, setNavOpen] = useState(false);
  const loc = useLocation();
  useLiveEvents(true);

  useEffect(() => {
    if (pid) {
      try {
        localStorage.setItem(LAST_PROJECT_KEY, pid);
      } catch {
        /* storage unavailable */
      }
    }
  }, [pid]);
  useEffect(() => setNavOpen(false), [loc.pathname]);

  return (
    <div className={`app ${navOpen ? "nav-open" : ""}`}>
      <Sidebar pid={pid} onNavigate={() => setNavOpen(false)} />
      <div className="nav-scrim" onClick={() => setNavOpen(false)} />
      <main className="main">
        <button className="btn-icon nav-toggle" onClick={() => setNavOpen(true)} aria-label="Open navigation">
          <Icon name="menu" />
        </button>
        <Outlet />
      </main>
    </div>
  );
}
